import { PropsWithChildren } from 'react';
import { Box, FelaCSS, colors } from '@bridebook/ui';
import AppBarMobileDefault from '@bridebook/web/components/app-bar/app-bar-mobile/default/app-bar-mobile-default';
import { TOPBAR_POSITION } from '@bridebook/web/lib/app-bar/constants';
import useWindowScroll from '@bridebook/web/lib/app-bar/use-window-scroll';
import useAppbannerHeight from '@bridebook/web/lib/app/use-appbanner-height';
import { getDownloadAppBannerHeight } from '@bridebook/web/lib/ui/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import componentStyles from './app-bar-mobile.style';

interface IProps extends PropsWithChildren {
  style?: FelaCSS;
  topStyle?: FelaCSS;
  scrolledStyle?: FelaCSS;
}

const defaultStyles: {
  top: FelaCSS;
  scrolled: FelaCSS;
} = {
  top: {
    backgroundColor: 'transparent',
  },
  scrolled: {
    backgroundColor: colors.white,
  },
};

const AppBarMobile = ({
  style = {},
  topStyle = defaultStyles.top,
  scrolledStyle = defaultStyles.scrolled,
  children,
}: IProps) => {
  const { isOnTop } = useWindowScroll();
  const scrollClassName = isOnTop ? TOPBAR_POSITION.ONTOP : TOPBAR_POSITION.SCROLLED;
  const appsFlyerBannerHeight = useAppbannerHeight();
  const downloadAppBannerHeight = useSelector(getDownloadAppBannerHeight);

  const styles = componentStyles({
    style,
    offsetTop: appsFlyerBannerHeight + (downloadAppBannerHeight || 0),
    topStyle,
    scrolledStyle,
  });

  return (
    <Box className={scrollClassName} style={styles.wrapper}>
      {children ? children : <AppBarMobileDefault />}
    </Box>
  );
};

export default AppBarMobile;
